import { render, staticRenderFns } from "./promote-feature-detail.vue?vue&type=template&id=0e890be4"
import script from "./promote-feature-detail.vue?vue&type=script&lang=ts"
export * from "./promote-feature-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports